/* =====================
   HASNIVA FLOW NAV (Shared)
   - Put this file in: assets/hasniva-flow-nav.js
   - Requires window.HASNIVA_FLOW_CONFIG on each page
===================== */

(function () {
  function cfg() {
    return window.HASNIVA_FLOW_CONFIG || {};
  }

  function getFlowState() {
    const key = cfg().FLOW_STORAGE_KEY;
    if (!key) return {};
    try { return JSON.parse(sessionStorage.getItem(key) || "{}") || {}; }
    catch { return {}; }
  }

  function setFlowState(patch) {
    const key = cfg().FLOW_STORAGE_KEY;
    if (!key) return {};
    const prev = getFlowState();
    const next = { ...prev, ...patch };
    sessionStorage.setItem(key, JSON.stringify(next));
    return next;
  }

  function ensureFlowDefaults() {
    const s = getFlowState();
    if (!s.maxStepUnlocked) setFlowState({ maxStepUnlocked: 1 });
  }

  function getCurrentStepFromPath() {
    const pages = (cfg().FLOW_PAGES || {});
    const p = location.pathname;

    if (pages[3] && p.includes(pages[3])) return 3;
    if (pages[2] && p.includes(pages[2])) return 2;
    return 1;
  }

  function renderFlowNav() {
    ensureFlowDefaults();

    const state = getFlowState();
    const pages = (cfg().FLOW_PAGES || {});
    const current = getCurrentStepFromPath();

    const allNavs = [
      document.getElementById("flowNavTop"),
      document.getElementById("flowNavBottom"),
    ].filter(Boolean);

    allNavs.forEach(nav => {
      const btns = nav.querySelectorAll(".flow-step-btn");
      btns.forEach(btn => {
        const step = Number(btn.getAttribute("data-step"));
        const isLocked = step > (state.maxStepUnlocked || 1);

        btn.classList.toggle("is-current", step === current);
        btn.classList.toggle("is-done", step < current);
        btn.classList.toggle("is-locked", isLocked);

        btn.onclick = () => {
          const currentStep = getCurrentStepFromPath();

          if (step === currentStep) {
            window.scrollTo({ top: 0, behavior: "smooth" });
            return;
          }

          if (step > (state.maxStepUnlocked || 1)) return;

          // Optional: page-1 can block 1->2 if needed (edited but not submitted)
          if (currentStep === 1 && step === 2) {
            const canProceed = cfg().canProceedFromStep1ToStep2;
            if (typeof canProceed === "function" && !canProceed()) {
              const onBlocked = cfg().onBlockedNext;
              if (typeof onBlocked === "function") onBlocked("ensure");
              return;
            }
          }

          if (pages[step]) location.href = pages[step];
        };
      });
    });

    const hintLeft = document.getElementById("flowHintLeft");
    if (hintLeft) hintLeft.textContent = `Step ${current} of 3`;
  }

  // Expose small API for pages to use
  window.HASNIVA_FLOW_NAV = {
    getFlowState,
    setFlowState,
    ensureFlowDefaults,
    getCurrentStepFromPath,
    renderFlowNav,
  };
})();
